export enum TestCaseType {
    SINGLE = 0,
    SCENARIO = 1,
}

// export const fromValue = (input: string) => {
//     for (let v: TestCaseType in TestCaseType) {
//         if (v.)
//     }
// }